import { createSelector } from '@reduxjs/toolkit'

import { TEMPLATES_LIST_REDUCER_NAME, TEMPLATES_REDUCER_NAME } from './consts'
import { makeFetchSelectors } from 'app/redux-fetch/selectors'
import { Config } from './types'
import { rootDomainsDataSelector } from 'features/rootDomains/selectors'

export const templatesSelector = makeFetchSelectors(
  TEMPLATES_REDUCER_NAME,
  TEMPLATES_LIST_REDUCER_NAME
)

export const templatesListSelector = createSelector(
  templatesSelector.data,
  (templates) => {
    const configs = templates?.configs || []

    return configs.map((config: Config) => ({
      id: config.id,
      name: config.name,
      uploaded: config.updated,
      version: `${config.currentVersion}`,
      downloadLink: config.url,
      integratorName: `${config?.firstName || ''} ${config?.lastName || ''}`,
    }))
  }
)

export const templatesListIsFetchingSelector = createSelector(
  [rootDomainsDataSelector.isFetching, templatesSelector.isFetching],
  (rootDomainIsFetching, templatesListIsFetching) =>
    rootDomainIsFetching || templatesListIsFetching
)

export const templatesListErrorSelector = createSelector(
  [rootDomainsDataSelector.error, templatesSelector.error],
  (rootDomainError, templatesListError) => rootDomainError || templatesListError
)

export const templatesListIsFinishedSelector = createSelector(
  [rootDomainsDataSelector.isFinished, templatesSelector.isFinished],
  (rootDomainIsFinished, templatesListIsFinished) =>
    rootDomainIsFinished && templatesListIsFinished
)
